<template>
  <div id="child-img">
    <img src="../../assets/images/Child.png" alt="" />
    <div class="insurance-introduce">
      <p class="details">
        {{ this.$t("lang.BetterMedicalCare.huizeDetail1") }}
      </p>
      <p>
        {{ this.$t("lang.BetterMedicalCare.huizeDetail2") }}
      </p>
    </div>
    <div class="be-careful">
      <p>
        {{ this.$t("lang.BetterMedicalCare.notes") }}
        <br />
        {{ this.$t("lang.BetterMedicalCare.beCarefulFirst") }}
        <br />
        {{ this.$t("lang.BetterMedicalCare.beCarefulSecond") }}
        <br />
        {{ this.$t("lang.BetterMedicalCare.beCarefulThird") }}
        <br />
        {{ this.$t("lang.BetterMedicalCare.beCarefulFourth") }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChildImg",
  components: {}
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#child-img {
  margin-top: 50px;
  width: 100%;
  img {
    width: 100%;
  }
  .insurance-introduce {
    width: 75%;
    margin: 50px auto 40px auto;
    font-size: 18px;
    color: #acacac;
    line-height: 34px;
    text-indent: 2em;
    .details {
      margin-bottom: 20px;
    }
  }
  .be-careful {
    width: 1060px;
    margin: 0 auto;
    line-height: 26px;
    font-size: 14px;
    color: #bfbfbf;
  }
}
</style>
